import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'color-box-column',
  template: `<color-box [text]="value" [config]="config"></color-box>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorBoxColumnComponent implements OnInit {

  @Input()
  searchTerm;
  @Input()
  columnValue;
  @Input()
  columnData;

  value: string;
  config;

  constructor() { }

  ngOnInit() {
    this.value = this.columnValue[this.columnData.columnName];
    this.config = this.columnData.configuration;
  }
}
